<!-- FIXME: This can use a confirm dialog instead of existing. -->
<template>
    <Modal id="members-confirm-modal"
           :title="title">
        <template v-slot:default>
            <p>
                {{ descriptionString }}
            </p>
        </template>

        <template v-slot:footer>
            <div class="modl-footer">
                <SquareBtn size="lg"
                           class="cancel-btn btn-danger"
                           @click="reject">
                    {{ l('CANCEL') }}
                </SquareBtn>

                <SquareBtn size="lg"
                           class="btn-warning"
                           @click="confirmWithoutSaving">
                    {{ l('MEMBERS_MODAL.CONFIRM_WITHOUT_SAVING') }}
                </SquareBtn>

                <SquareBtn size="lg"
                           class="btn-success"
                           @click="confirmAndSave">
                    {{ l('MEMBERS_MODAL.CONFIRM_AND_SAVE') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import SquareBtn from '@/vue/components/SquareBtn';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: { SquareBtn, Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        descriptionString: {
            type: String,
            default: '',
        },

        title: {
            type: String,
            default: 'MEMBERS_MODAL.TITLE',
        },
    },

    methods: {
        confirmWithoutSaving() {
            this.resolve({
                keepUnsavedMembers: false,
            });
        },

        confirmAndSave() {
            this.resolve({
                keepUnsavedMembers: true,
            });
        },
    },
};
</script>
